import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
export const ChecklistItemName = z.enum([
    "Investor Profile",
    "Contact Information",
    "Additional Information",
    "Beneficiaries",
    "Affiliations",
    "Onboarding Agreement",
    "Privacy Policy",
    "Investment Advisory Agreement",
    "Disclosures",
    "Custodian Agreement",
]);
export const ClientChecklistItemStatus = z.enum([
    "Not Started",
    "In Progress",
    "Completed",
]);
export const ClientChecklistItem = z.object({
    name: ChecklistItemName,
    status: ClientChecklistItemStatus,
});
export const ClientChecklist = z.object({
    showChecklist: z.boolean(),
    items: ClientChecklistItem.array(),
});
export const clientChecklistUrl = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/entity/v1/clientside/${clientId}/checklist`
    : `https://middleware.uat.farther.com/entity/v1/clientside/${clientId}/checklist`;
export default async function getClientChecklist(clientId, config) {
    const { data } = await axios.get(clientChecklistUrl(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = ClientChecklist.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getClientChecklist] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientChecklist.js.map